import { render } from "./Holiday.vue?vue&type=template&id=72302ece"
import script from "./Holiday.vue?vue&type=script&lang=js"
export * from "./Holiday.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hr.tomorrow.services/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__